import React from "react";

import "./index.scss";

const Box = ({ status, text }) => {
  return (
    <div className={`box${status ? ` ${status}` : ""}`}>
      <h2>{text}</h2>
    </div>
  );
};

export default Box;
